import InstallPWA from './installPWA'

export default InstallPWA